/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SkillEditSuggestion,
  SkillEditSuggestion$inboundSchema,
} from "./skilleditsuggestion.js";

/**
 * A page of open skill edit suggestions.
 */
export type ListSkillSuggestionsResult = {
  /**
   * Cursor for the next page; absent when exhausted.
   */
  nextCursor?: string | undefined;
  /**
   * The open suggestions in this page.
   */
  suggestions: Array<SkillEditSuggestion>;
  /**
   * The total number of matching open suggestions, independent of pagination.
   */
  totalOpenCount: number;
};

/** @internal */
export const ListSkillSuggestionsResult$inboundSchema: z.ZodMiniType<
  ListSkillSuggestionsResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    suggestions: z.array(SkillEditSuggestion$inboundSchema),
    total_open_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
      "total_open_count": "totalOpenCount",
    });
  }),
);

export function listSkillSuggestionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillSuggestionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillSuggestionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillSuggestionsResult' from JSON`,
  );
}
